import AppContext from "PFApp/app_context";
import { Threshold, ThresholdKind } from "PFTypes";
import { useContext } from "react";

export const useThresholds = (kinds: ThresholdKind[]): Record<string, Threshold[]> => {
  const {
    store: {
      currentAccount: { thresholds }
    }
  } = useContext(AppContext);

  const data = kinds.map((kind) => ({ [kind]: thresholds?.filter((item) => item.kind === kind) || [] }));

  return Object.assign(
    {},
    data.reduce((total, acc) => ({ ...acc, ...total }), {})
  );
};
